import { createFeatureSelector } from '@ngrx/store';
import { Message } from 'src/app/shared/models/message';
import { AppState } from '../../core.module';

export namespace MessagesSelectors {
  export const getMessages = createFeatureSelector<AppState, Message[]>(
    'messages'
  );
}
